import { features } from "@/mocks/homeData";

export default function TrackFeatures() {
  return (
    <section id="features" className="mx-auto w-full max-w-6xl scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-widest text-primary-600">追踪维度</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            六条追踪线，拼出事件人物完整画像
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            不满足于「谁被曝了」，更想厘清来龙去脉？从这六个公开信息维度切入，让每条线索都站得住脚。
          </p>
        </div>
        <a
          href="#archives"
          className="inline-flex items-center gap-2 rounded-md border border-secondary-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
        >
          去档案里看效果
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((f, idx) => (
          <article
            key={f.title}
            className={`group relative overflow-hidden rounded-lg border p-5 transition-colors md:p-6 ${
              f.accent
                ? "border-primary-200 bg-primary-50"
                : "border-background-200/70 bg-background-100/60 hover:border-secondary-300"
            }`}
          >
            <span
              className={`absolute -right-3 -top-5 font-heading text-7xl font-bold ${
                f.accent ? "text-primary-100" : "text-secondary-100"
              }`}
            >
              {String(idx + 1).padStart(2, "0")}
            </span>
            <div
              className={`relative flex h-12 w-12 items-center justify-center rounded-md text-2xl ${
                f.accent ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-900"
              }`}
            >
              <i className={f.icon} />
            </div>
            <h3 className="relative mt-4 font-heading text-lg font-bold text-foreground-900">{f.title}</h3>
            <p className="relative mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            <div className="relative mt-4 flex items-center gap-2 border-t border-background-200/70 pt-3">
              <i className="ri-bar-chart-2-line text-accent-600" />
              <span className="text-xs font-medium text-accent-700">{f.kpi}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}